module.exports = __webpack_public_path__ + "img/portal-icon-dark.922e1288.svg";